import { showError } from "Utils";
import { Avatar, Button } from "@mui/material";

const AvatarSection = ({ value: avatar, onChange: setAvatar }) => {

  const handleFileChange = (event) => {
    if (!event.target.value) {
      setAvatar(null);
      return;
    }

    const file = event.target.files[0];

    if (!isValidImageFile(file)) {
      return;
    }

    setAvatar(file);
  };

  const isValidImageFile = (file) => {
    if (!file.type.toString().includes("image")) {
      showError({
        title: 'Oops',
        message: 'This File type is not allowed, please try again',
      });
      return false;
    } else if (file.size > 1024 * 1024) {
      showError({
        title: 'Oops',
        message: 'The File Size must be less than 1MB',
      });
      return false;
    }

    return true;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
      }}
    >
      {avatar ? (
        <Avatar
          src={avatar ? URL.createObjectURL(avatar) : ""}
          alt="Avatar"
          sx={{
            width: 100,
            height: 100,
          }}
        />
      ) : (
        <Avatar
          sx={{
            width: 100,
            height: 100,
          }}
        />
      )}
      <input
        accept="image/*"
        id="avatar-upload"
        type="file"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <label htmlFor="avatar-upload">
        <Button component="span" variant="outlined" color="primary">
          Upload Avatar
        </Button>
      </label>
    </div>
  );
};

export default AvatarSection;
